import { render, staticRenderFns } from "./GroupDimension.vue?vue&type=template&id=806e23ec&scoped=true&"
import script from "./GroupDimension.vue?vue&type=script&lang=js&"
export * from "./GroupDimension.vue?vue&type=script&lang=js&"
import style0 from "./GroupDimension.vue?vue&type=style&index=0&id=806e23ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806e23ec",
  null
  
)

export default component.exports